
export default {
  name: 'AppLayout'
}
